import React from "react";

const CheckedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4716 4.86215C12.7319 5.12257 12.7317 5.54468 12.4713 5.80496L7.13484 11.1383C7.00975 11.2633 6.84012 11.3335 6.66328 11.3334C6.48643 11.3333 6.31686 11.263 6.19189 11.1379L3.52836 8.47121C3.26816 8.21071 3.26841 7.7886 3.52891 7.5284C3.78942 7.2682 4.21153 7.26845 4.47172 7.52895L6.66399 9.7238L11.5288 4.86187C11.7892 4.6016 12.2113 4.60172 12.4716 4.86215Z"
        fill="#537BFF"
      />
    </svg>
  );
};

export default CheckedIcon;
